"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    // Nav
    'landing.nav.about': 'O systemie',
    'landing.nav.modules': 'Moduły',
    'landing.nav.assistants': 'Asystenci AI',
    'landing.nav.contentStudio': 'Content Studio',
    'landing.nav.analytics': 'Analityka',
    'landing.nav.login': 'Zaloguj się',
    // Hero
    'landing.hero.eyebrow': 'Platforma AI dla firm',
    'landing.hero.title1': 'Jeden panel.',
    'landing.hero.title2': 'Wszystkie modele AI',
    'landing.hero.title3': 'Twojej firmy.',
    'landing.hero.lede': 'IntHub spina GPT-5, Claude, Gemini i DeepSeek w jednym miejscu — razem z asystentami, planowaniem treści, raportami kosztów i zarządzaniem zespołem. Bez przełączania się między dziesięcioma narzędziami.',
    'landing.hero.ctaLogin': 'Zaloguj się do panelu',
    'landing.hero.ctaModules': 'Zobacz moduły',
    'landing.hero.note': 'testhub.intgate.io — panel dostępny dla zalogowanych firm',
    'landing.hero.deviceTitle': 'Zacznij rozmawiać ze swoim asystentem AI',
    'landing.hero.deviceSub': 'Wybierz model, styl pisania i podłącz wiedzę — jednym poleceniem.',
    'landing.hero.deviceInput': '/ style · # projekt · @ wiedza — wpisz swoje pytanie…',
    // Model Chips
    'landing.model.openai': 'OpenAI · GPT-5',
    'landing.model.claudeSonnet': 'Claude Sonnet 4.6',
    'landing.model.deepseek': 'DeepSeek V3.2',
    'landing.model.gemini': 'Gemini 3.5 Flash',
    'landing.model.claudeHaiku': 'Claude Haiku 4.5',
    // Intro
    'landing.intro.eyebrow': 'Wprowadzenie',
    'landing.intro.title': 'Centrum dowodzenia AI dla całej organizacji',
    'landing.intro.lede1': 'Zamiast rozpraszać pracę między dziesiątkami zakładek, IntHub gromadzi rozmowy z modelami AI, wirtualnych asystentów, planowanie treści i raporty kosztów w jednym systemie. Każda firma działa w swojej przestrzeni — z własnymi użytkownikami, rolami, budżetem kredytowym i zestawem modeli.',
    'landing.intro.lede2': 'System jest wielofirmowy od podstaw: jedno konto administracyjne może obsługiwać wiele firm, branż i zespołów, a każda operacja w bazie danych zostaje zapisana w logu audytowym.',
    // Stats
    'landing.stat.providers': '4 dostawców',
    'landing.stat.providersLab': 'OpenAI, Anthropic, DeepSeek, Google — jeden interfejs czatu',
    'landing.stat.roles': '3 role',
    'landing.stat.rolesLab': 'Super Admin, Manager, Użytkownik — precyzyjne uprawnienia',
    'landing.stat.multitenant': 'Multi-tenant',
    'landing.stat.multitenantLab': 'Wiele firm, branż i zespołów w jednym systemie',
    'landing.stat.credits': 'Kredyty',
    'landing.stat.creditsLab': 'Rozliczenie zużycia AI w przejrzystym modelu subskrypcji',
    // Modules
    'landing.modules.eyebrow': 'Moduły',
    'landing.modules.title': 'Co dokładnie znajdziesz w IntHub',
    'landing.modules.lede': 'Dziewięć modułów, jedno logowanie. Każdy z nich odpowiada za inny etap pracy z AI w firmie — od rozmowy po rozliczenie.',
    // Module Cards
    'landing.module.chat.title': 'Czat AI wielomodelowy',
    'landing.module.chat.desc': 'Rozmawiaj z GPT-5, Claude, Gemini lub DeepSeek z jednego okna. Komendą „/" włączasz styl pisania, "#" podłączasz projekt, a "@" bazę wiedzy — bez przełączania kart.',
    'landing.module.assistants.title': 'Wirtualni Asystenci',
    'landing.module.assistants.desc': 'Twórz awatary z własną osobowością, płcią i modelem AI. Każdy przechodzi listę zadań szkoleniowych i dostaje własną bazę wiedzy, zanim trafi do pracy.',
    'landing.module.knowledge.title': 'Baza Wiedzy',
    'landing.module.knowledge.desc': 'Podłącz dokumenty i dane firmowe do konkretnego asystenta lub projektu, żeby odpowiedzi trzymały się faktów Twojej firmy, a nie ogólników.',
    'landing.module.contentStudio.title': 'Content Studio',
    'landing.module.contentStudio.desc': 'Planuj posty, przypisuj kanały i śledź status od szkicu po publikację. Asystent AI podpowiada tematy, plan treści i najlepsze godziny publikacji.',
    'landing.module.styles.title': 'Style Pisania',
    'landing.module.styles.desc': 'Zapisz ton głosu marki — od formalnego, jak w korespondencji zawodowej, po młodzieżowy slang — i udostępnij go całemu zespołowi jednym przełącznikiem.',
    'landing.module.costs.title': 'Raporty Kosztów',
    'landing.module.costs.desc': 'Śledź tokeny, koszt na wiadomość i najaktywniejsze awatary w rozbiciu na użytkownika, firmę i wybrany okres — z wykresem trendu na żywo.',
    'landing.module.management.title': 'Zarządzanie Firmami i Zespołem',
    'landing.module.management.desc': 'Prowadź wiele firm z osobnymi modułami, branżami i zawodami. Nadawaj role Super Admin, Manager i Użytkownik do każdego konta.',
    'landing.module.logs.title': 'Logi Audytowe i Dostępy',
    'landing.module.logs.desc': 'Każde utworzenie i aktualizacja rozmowy, wiadomości czy kursu walut trafia do logu bazy danych — z pełnym podglądem danych wejściowych i wyniku operacji.',
    'landing.module.pricing.title': 'Pakiety i Płatności',
    'landing.module.pricing.desc': 'Od darmowego planu po Ultra bez limitów — liczba użytkowników, awatarów i funkcji rośnie razem z firmą, rozliczana w miesięcznych kredytach.',
    // Assistants Showcase
    'landing.assistants.eyebrow': 'Asystenci AI',
    'landing.assistants.title': 'Zespół botów, który rośnie razem z firmą',
    'landing.assistants.lede': 'Każdy asystent to osobny pracownik AI: własny model, osobowość, płeć i zakres wiedzy. Historyk odpowiada inaczej niż asystent księgowości — bo uczysz ich osobno, listą zadań szkoleniowych.',
    'landing.assistants.feature1': 'Dowolny model do każdego awatara — Claude, DeepSeek, Gemini',
    'landing.assistants.feature2': 'Lista zadań szkoleniowych przed dopuszczeniem do pracy',
    'landing.assistants.feature3': 'Własna baza wiedzy i widok listy lub siatki asystentów',
    // Avatar Cards
    'landing.avatar.historian': 'Historyk',
    'landing.avatar.historianRole': 'Claude Sonnet 4.6',
    'landing.avatar.hive': 'Asystent HIVE',
    'landing.avatar.hiveRole': 'DeepSeek V3.2 · Programista',
    'landing.avatar.communicator': 'Komunikator',
    'landing.avatar.communicatorRole': 'Gemini 3.5 Flash',
    'landing.avatar.whatsapp': 'Whatsapp',
    'landing.avatar.whatsappRole': 'Claude Haiku 4.5',
    'landing.avatar.statusConfig': 'Konfiguracja zakończona',
    // Content Studio Showcase
    'landing.cs.eyebrow': 'Content Studio',
    'landing.cs.title': 'Od pomysłu do publikacji, bez arkusza kalkulacyjnego',
    'landing.cs.lede': 'Biblioteka postów pokazuje, co jest szkicem, co czeka na akceptację, a co już poszło do sieci. Zapytaj Asystenta AI o temat, plan na tydzień albo najlepszą godzinę publikacji — odpowiada na podstawie Twojej biblioteki.',
    'landing.cs.feature1': 'Statusy: szkic, zaplanowany, do akceptacji, opublikowany',
    'landing.cs.feature2': 'Harmonogram i historia publikacji w jednym miejscu',
    'landing.cs.feature3': 'Asystent AI podpowiada tematy na podstawie zaangażowania',
    // CS Stats
    'landing.cs.statScheduled': 'Zaplanowane (7 dni)',
    'landing.cs.statApproval': 'Do akceptacji',
    'landing.cs.statPublished': 'Opublikowane (30 dni)',
    'landing.cs.statTotal': 'Łącznie postów',
    // CS Post
    'landing.cs.postTitle': 'Testujemy API',
    'landing.cs.postStatus': 'Opublikowany',
    'landing.cs.postContent': '"Cześć! Dziś pokazujemy, jak krok po kroku przetestować API. Idealne dla początkujących programistów…"',
    // CS Suggestions
    'landing.cs.suggest1': 'Jakie tematy przyniosą najlepsze zaangażowanie?',
    'landing.cs.suggest2': 'Zaproponuj plan treści na przyszły tydzień',
    'landing.cs.suggest3': 'Kiedy najlepiej publikować?',
    // Analytics
    'landing.analytics.eyebrow': 'Analityka',
    'landing.analytics.title': 'Każdy token rozliczony co do grosza',
    'landing.analytics.lede': 'Raporty kosztów filtrujesz po dacie, użytkowniku, awatarze lub firmie. Widzisz łączny koszt, liczbę tokenów, średni koszt wiadomości i który awatar generuje najwięcej ruchu — z wykresem trendu w czasie.',
    'landing.analytics.feature1': 'Filtry po dacie, użytkowniku, awatarze i firmie',
    'landing.analytics.feature2': 'Wykres trendu kosztów i tokenów w czasie',
    'landing.analytics.feature3': 'Ranking najaktywniejszego awatara w organizacji',
    // Analytics Stats
    'landing.analytics.totalCost': 'Całkowity koszt',
    'landing.analytics.tokens': 'Tokeny',
    'landing.analytics.messages': 'Wiadomości',
    'landing.analytics.avgCost': 'Śr. koszt / wiadomość',
    'landing.analytics.topMessages': 'Wiadomości top awatara',
    'landing.analytics.topAvatar': 'Top awatar',
    // Management
    'landing.management.eyebrow': 'Zarządzanie i bezpieczeństwo',
    'landing.management.title': 'Struktura wielofirmowa, kontrola na każdym poziomie',
    'landing.management.lede': 'Jedna instalacja obsługuje wiele firm, branż i zawodów — a każda zmiana w bazie zostaje zapisana, zanim ktokolwiek zapyta "kto to zmienił?".',
    'landing.management.companies.title': 'Firmy, użytkownicy, role',
    'landing.management.companies.desc': 'Dodawaj firmy z NIP-em, adresem i przypisanymi modułami. Każdemu kontu nadajesz rolę — Super Admin, Manager lub Użytkownik — oraz grupę i użytkownika nadrzędnego.',
    'landing.management.logs.title': 'Logi audytowe bazy danych',
    'landing.management.logs.desc': 'Filtruj log po dacie, modelu i typie operacji. Do każdego wpisu podejrzysz dokładne dane wejściowe i wynik — przydatne przy rozliczaniu kosztów i diagnozowaniu błędów.',
    // Mini Table
    'landing.management.table.company': 'Firma',
    'landing.management.table.city': 'Miasto',
    'landing.management.table.status': 'Status',
    'landing.management.table.model': 'Model',
    'landing.management.table.operation': 'Operacja',
    'landing.management.table.date': 'Data',
    'landing.management.company1': 'Studio Nord Sp. z o.o.',
    'landing.management.company2': 'Kancelaria Wschód',
    'landing.management.company3': 'Biuro Rachunkowe Miller',
    'landing.management.warsaw': 'Warszawa',
    'landing.management.krakow': 'Kraków',
    'landing.management.elk': 'Ełk',
    'landing.management.active': 'Aktywna',
    'landing.management.opConversation': 'Rozmowa',
    'landing.management.opMessage': 'Wiadomość',
    'landing.management.opCurrency': 'Kurs walut',
    'landing.management.opCreate': 'Utwórz',
    'landing.management.opUpdate': 'Aktualizuj',
    // CTA Final
    'landing.cta.eyebrow': 'Gotowe do startu',
    'landing.cta.title': 'Scentralizuj AI w swojej firmie już dziś',
    'landing.cta.lede': 'Zaloguj się do panelu testowego i skonfiguruj pierwszego asystenta w kilka minut.',
    'landing.cta.button': 'Przejdź do logowania',
    // Footer
    'landing.footer.copyright': '© 2026 IntHub. Wszelkie prawa zastrzeżone.',
    'landing.footer.panel': 'Panel logowania',
    // Image alt texts
    'landing.img.logo': 'IntHub',
    'landing.img.bg1': 'Stanowisko pracy z AI',
};
